import {Screen} from './Screen'

export const Contact = () => {
  return <Screen />
}
